/** 端口 */
export const ShowPort = {
    /** 骑手 */
    RIDER_APP: 'RIDER_APP',

    /** 客户端 */
    USER_APP: 'USER_APP',

};

/** 角色类型 */
export const RoleType = {
    /** 客户端 */
    client: 'RIDER_APP',

    /** 骑手 */
    rider: 'USER_APP'
};

/** 投放状态 */
export const PutType = {
    /** 投放中 */
    puting: 1,

    /** 历史投放 */
    puted: 0
};

/** 表格列表字段 */
export const MainTableFields = {
    /** 广告位名称 */
    adSpaceName: 'name',

    /** 使用位置 */
    adPosition: 'description',

    /** 投放中广告数量 */
    putAdTotal: 'num',

    /** 状态 */
    state: 'state',

};

/** 表格操作类型 */
export const TableAction = {
    /** 广告位置 */
    adPosition: 'adPosition',

    /** 状态 */
    state: 'state',

    /** 管理 */
    manage: 'manage'
};

/** 广告表格字段 */
export const AdvertListFields = {
    /** 图片 */
    adImg: 'coverUrl',

    /** 广告名称 */
    adName: 'title',

    /** 投放时间 */
    putTime: 'startTime',

    /** 状态 */
    state: 'state',

    /** 排序 */
    sort: 'sort'
};
